import React from 'react';
import { ButtonTextTransform, TypographyVisualStyle } from 'react-magma-dom';
import Riley from '../../assets/Riley';
import {
  FlexWrapper,
  StyledBlackParagraph,
  StyledBasicModal,
  StyledIntroductionToHybridContentWrapper,
  StyledIntroductionToHybridContainer,
  StyledIntroductionToHybridImage,
  StyledNoMarginButton,
  MarginWrapper,
  StyledIntroductionToHybridParagraph,
} from '../Styled';

interface IHybridIntroductionModal {
  showModal: boolean;
  setShowModal: () => void;
}

export const IntroductionToHybridModal = (props: IHybridIntroductionModal): JSX.Element => {
  const { showModal, setShowModal } = props;
  const hybridModalContainerStyles = { paddingTop: '184px' };

  return (
    <StyledBasicModal
      isOpen={showModal}
      onClose={setShowModal}
      containerStyle={hybridModalContainerStyles}
      isBackgroundClickDisabled
      testId="introduction-to-hybrid-modal"
    >
      <FlexWrapper>
        <StyledIntroductionToHybridImage>
          <Riley />
        </StyledIntroductionToHybridImage>
        <MarginWrapper margin="24px 0px 43px 0px">
          <StyledIntroductionToHybridParagraph>Introduction to Hybrid Text</StyledIntroductionToHybridParagraph>
          <StyledIntroductionToHybridContainer>
            <StyledIntroductionToHybridContentWrapper>
              <StyledBlackParagraph visualStyle={TypographyVisualStyle.bodyMedium}>
                A hybrid text results from a blend of two or more different text types. Many hybrid texts combine a
                narrative with a factual text type. Usually, one text type is more dominant than the other.
              </StyledBlackParagraph>
              <StyledBlackParagraph visualStyle={TypographyVisualStyle.bodyMedium}>
                Each text type within the hybrid text retains some of the typical structural features and many of the
                language features of the individual text type.
              </StyledBlackParagraph>
              <StyledBlackParagraph visualStyle={TypographyVisualStyle.bodyMedium}>
                The placement of the individual text types within the hybrid text can differ, therefore the overall
                structure of a hybrid text can have many variations.
              </StyledBlackParagraph>
            </StyledIntroductionToHybridContentWrapper>
            <StyledNoMarginButton testId="continue-btn" textTransform={ButtonTextTransform.none} onClick={setShowModal}>
              Continue
            </StyledNoMarginButton>
          </StyledIntroductionToHybridContainer>
        </MarginWrapper>
      </FlexWrapper>
    </StyledBasicModal>
  );
};
